<p>
  Клик по строке — SPA-переход; <b>Ctrl/⌘+клик</b> или <b>средняя кнопка</b> — новая вкладка;
  наведите — браузер покажет целевой URL. Кнопка действия и чекбокс переход не запускают.
</p>
<aur-mat-table [tableConfig]="cfg" [tableData]="data" (rowAction)="onAction($event)"></aur-mat-table>
<p *ngIf="lastAction">Последнее действие (без навигации): {{ lastAction }}</p>
